import { generateRandomString } from '@mntn-dev/utilities'
import { z } from 'zod'

export const TipaltiIdSchema = z.string().brand('tipalti-id')

export type TipaltiId = z.infer<typeof TipaltiIdSchema>

export const TipaltiId = (
  value: string = generateRandomString()
): TipaltiId => {
  return TipaltiIdSchema.parse(value)
}
